import template from './view-cart.html';
import controller from './view-cart.controller';
import './view-cart.less';

let viewCartComponent = {
    restrict: 'E',
    bindings: {viewCartModel: '='},
    template,
    controller
};

export default viewCartComponent;



// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart.component.js